<template>
    <div>
        <div>
            <el-button type="danger" @click="removeItems()">删除</el-button>
            <el-button type="primary" @click="editIPConfigFunc()">编辑</el-button>

            <div class="common-search">
                <el-input
                        v-model="searchVal"
                        class="common-el-input"
                        @keyup.enter="getList()"
                        placeholder="请输入玩家ID、昵称或设备码进行查询">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
                <el-button type="primary" @click="getList()">搜索</el-button>
            </div>
        </div>

        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="userImeiLoginList.beanList"
                    row-key="userRandomId"
                    height="100%"
                    @selection-change="selection = $event">
                <el-table-column type="selection" width="55"/>
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" min-width="150" align="center" prop="userNickname"/>
                <el-table-column label="俱乐部" width="180" align="center" prop="clubName"/>
                <el-table-column label="可提/不可提/金豆数" min-width="250" align="center">
                    <template slot-scope="scope">
                        {{scope.row.extractableChip}}/{{scope.row.notExtractableChip}}/{{scope.row.extractableChip +
                        scope.row.notExtractableChip}}
                    </template>
                </el-table-column>
                <el-table-column label="玩家身份" align="center" prop="userType">
                    <template slot-scope="scope">{{scope.row.userType | userTypeName}}</template>
                </el-table-column>
                <el-table-column label="联系方式" width="150" align="center" prop="userPhone"/>
                <el-table-column label="设备码" min-width="300" align="center">
                    <template slot-scope="scope">{{scope.row.imeiList.join(',')}} <i class="el-icon-edit-outline"
                                                                                     @click="editIPConfigFunc(scope.row)"></i>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="100">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="removeItem([scope.row.userId])">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="userImeiLoginList.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>

        <div v-show="showIPConfig" class="common-popup-bg">
            <div class="common-popup">
                <h3>编辑玩家登录设备码</h3>
                <div style="padding: 20px 30px">
                    <el-input
                            type="textarea"
                            rows="4"
                            resize="none"
                            v-model="imeiSet"
                            style="width: 280px;"
                            placeholder="请输入"/>
                </div>
                <footer>
                    <el-button size="small" @click="showIPConfig = false">取消</el-button>
                    <el-button size="small" type="primary" @click="submitIPConfig">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                showIPConfig: false,
                searchVal: '',
                selection: [],
                currentPage: 1,
                imeiSet: '',
                userId: '',
            }
        },
        computed: {
            ...mapState('user', ['userImeiLoginList'])
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('user', ['getUserImeiLoginList', 'addUserImeiLogin', 'updateUserImeiLogin', 'deleteUserImeiLogin']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getUserImeiLoginList({
                    search: this.searchVal,
                    page
                }).then(() => {
                    this.loading = false;
                    if (!this.userImeiLoginList.beanList.length && page !== 1) {
                        this.getList(this.currentPage - 1)
                    }
                });
            },
            removeItem(userIdSet){
                this.$confirm('确认删除吗？', '提示', {
                    type: 'info'
                }).then(() => {
                    this.deleteUserImeiLogin({
                        userIdSet
                    }).then(() => {
                        this.$message.success('删除成功');
                        this.getList(this.currentPage)
                    })
                }).catch(() => {
                })
            },
            removeItems() {
                if (!this.selection.length) {
                    this.$message.info('请先选择您要删除的玩家');
                    return;
                }
                this.removeItem(this.selection.map(item => item.userId));
            },
            editIPConfigFunc(row = null) {
                if (!this.selection.length && !row) {
                    this.$message.info('请先选择您要设置的玩家');
                    return;
                }
                if (row) {
                    this.userId = row.userId;
                    this.imeiSet = row.imeiList.join(',');
                }
                this.showIPConfig = true;
            },
            // 添加登录限制
            submitIPConfig() {
                if (this.userId) {
                    this.updateUserImeiLogin({
                        imeiSet: this.imeiSet.split(','),
                        userId: this.userId
                    }).then(() => {
                        this.$message.success('修改成功');
                        this.userId = '';
                        this.imeiSet = '';
                        this.showIPConfig = false;
                        this.getList(this.currentPage)
                    })
                } else {
                    this.addUserImeiLogin({
                        imeiSet: this.imeiSet.split(','),
                        userIdSet: this.selection.map(item => {
                            return item.userId
                        })
                    }).then(() => {
                        this.$message.success('添加成功');
                        this.imeiSet = '';
                        this.showIPConfig = false;
                        this.getList(this.currentPage)
                    })
                }

            }
        }
    }
</script>
<style lang="scss" scoped>
    .el-icon-edit-outline {
        color: $theme-color;
        cursor: pointer;
    }
</style>

